import { memo, useContext, useEffect } from 'react';
import SignIn from '@pages/auth/SignIn.jsx';
import ForgetPass from '@pages/auth/ForgetPass.jsx';
import VerifyAcc from '@pages/auth/VerifyAcc.jsx';
import ResetPass from '@pages/auth/ResetPass.jsx';
import { Routes as RoutesWrapper, Route, useNavigate } from 'react-router-dom';
import { PrivilegeContext } from '@/context/PrivilegesContext';
const PublicRoutes = () => {

    const { isLoggedIn } = useContext(PrivilegeContext)

    const navigate = useNavigate()
    useEffect(() => {
        if (isLoggedIn) return navigate("/panel")
    }, [isLoggedIn])

    return (
        <RoutesWrapper>
            <Route path="log-in" element={<SignIn />} />
            <Route path="forget-password" element={<ForgetPass />} />
            <Route path="verify-account" element={<VerifyAcc />} />
            <Route path="reset-password" element={<ResetPass />} />
        </RoutesWrapper>
    )
}

export default memo(PublicRoutes)